import './App.css';
import './index.css';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import {
  BrowserRouter as Router,
  Route, Switch, Routes,
  Link
} from "react-router-dom";
import Home from './Component/Home/Home';
import Login from './Login/Login';
import Register from './Register/Register';
import Goldprice from './Component/Goldprice';
import Silverprice from './Component/Silverprice';
import Contact from './Component/Contact';
import TermsConditions from './Component/TermsConditions';
import PrivacyPolicy from './Component/PrivacyPolicy';
import AboutUs from './Component/AboutUs';
import FAQ from './Component/faq';
import Listing from './Component/Listing/Listing';
import Dashboard from './Component/Dashboard/Dashboard';
import Profile from './Component/Dashboard/Profile';
import Changedpassword from './Component/Dashboard/Changedpassword';
import Listproduct from './Component/Dashboard/Listproduct';
import Editproduct from './Component/Dashboard/Editproduct';
import Listwishlist from './Component/Dashboard/Listwishlist';
import ChatInbox from './Component/Dashboard/ChatInbox';
import Sellproduct from './Component/Dashboard/Sellproduct';
import ProtectedRoute from './Component/ProtectedRoute';
import Productdetails from './Component/Productdetails/Productdetails';
import ScrollToTop from './Component/ScrollToTop';
import ResetPassword from './ResetPassword/ResetPassword';


function App() {
  return (
    <div className="App">
      <Router basename="/">
      {/* <Router> */}
      <ScrollToTop />
        <Header />
        <Switch>
          <Route exact path="/"><Home /></Route>
          <Route exact path="/details/:id"><Productdetails/></Route>
          <Route exact path="/listing"><Listing/></Route>
          <Route exact path="/login"><Login /></Route>
          <Route exact path="/register"><Register /></Route>
          <Route exact path="/reset-password/:token"><ResetPassword /></Route>
          <Route exact path="/price"><Goldprice /></Route>
          <Route exact path="/silver-price"><Silverprice /></Route>
          <Route exact path="/contact"><Contact /></Route>
          <Route exact path="/terms-conditions"><TermsConditions /></Route>
          <Route exact path="/privacy-policy"><PrivacyPolicy /></Route>
          <Route exact path="/about-us"><AboutUs /></Route>
          <Route exact path="/faq"><FAQ /></Route>
          <ProtectedRoute path="/dashboard" component={Dashboard} />
          <ProtectedRoute path="/profile" component={Profile} />
          <ProtectedRoute path="/changed-password" component={Changedpassword} />
          <ProtectedRoute path="/sell-product" component={Sellproduct} />
          <ProtectedRoute path="/list-product" component={Listproduct} />
          <ProtectedRoute path="/edit-product/:id" component={Editproduct} />
          <ProtectedRoute path="/list-wishlist" component={Listwishlist} />
          <ProtectedRoute path="/inbox" component={ChatInbox} />

        </Switch>
        <Footer />
      </Router>
    </div>

  );
}

export default App;
